'use strict';

angular.module('ClinicApp').controller('ModalClinicAwardVerifyCtrl', function($scope, $modalInstance, $q, clinic, enableGuideOnFail, ClinicService, OCDomUtil, OCModalUtil, ClinicConfig, GrowlService, CurrentUser) {
  $scope.clinic = clinic;
  $scope.user = CurrentUser.getUser();
  $scope.enableGuideOnFail = !!enableGuideOnFail;
  $scope.userEntered = {
    website: null,
  };
  $scope.award = {
    submitted: false,
    verified: false,
  };

  $scope.verify = function() {
    var website = $scope.userEntered.website;

    if (!website) {
      return $q.reject();
    }

    return ClinicService.verifyAward($scope.clinic.id, website).then(function(result) {
      $scope.award.verified = result.verified;

      if ($scope.award.verified) {
        // Save information about the verified award to the specific Google Spreadsheet.
        var action = 'https://docs.google.com/forms/d/1YU-hRxA9a5UiRkIaxE3hfiHp3zv2VcXcS_UTXztrVr8/formResponse';
        var data = {
          'entry.1728568661': $scope.clinic.id,
          'entry.195618400': $scope.clinic.name,
          'entry.313371910': $scope.clinic.address.locality,
          'entry.1789987077': $scope.user ? $scope.user.email : '',
          'entry.846129067': $scope.user ? $scope.user.firstName : '',
          'entry.98681462': website,
          'entry.192088795': $scope.clinic.primarySpecialty.field,
          'entry.1459032453': ClinicConfig.CLINIC_APP_URL,
        };

        return OCDomUtil.submitThroughIframe(action, 'POST', data);
      }
    })
      .then(function() {
        $scope.award.submitted = true;
      });
  };

  $scope.verifyAgain = function() {
    $scope.award.submitted = false;
  };

  $scope.emailCodeSnippet = function() {
    return ClinicService.getClinicAward($scope.clinic.id).then(function() {
      GrowlService.success('Copy of the digital award is sent to your email ' + $scope.user.email);
    });
  };

  $scope.openAwardGuide = function() {
    OCModalUtil.showModal(
      'claimAwardGuide',
      {
        clinic: $scope.clinic,
        user: $scope.user,
        awardPlacementType: 2,
      },
    ).then($scope.verifyAgain);
  };

  $scope.close = function() {
    $modalInstance.close();
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };
});
